import { useState } from 'react';

interface ConnectControllerButtonProps {
  onConnect: () => Promise<void>;
}

// First-time WebHID authorization affordance. Sits unobtrusively in a corner and
// is only meant to be rendered while a controller still needs granting — once
// authorized, controllers reconnect silently and the parent stops rendering it.
export function ConnectControllerButton({
  onConnect,
}: ConnectControllerButtonProps) {
  const [isConnecting, setIsConnecting] = useState(false);

  return (
    <button
      type="button"
      disabled={isConnecting}
      onClick={async () => {
        setIsConnecting(true);
        try {
          await onConnect();
        } catch {
          // User dismissed the chooser or the device was busy; ignore.
        } finally {
          setIsConnecting(false);
        }
      }}
      className="fixed bottom-3 left-3 z-50 flex items-center gap-1.5 rounded-md border border-primary/20 bg-black/60 px-2.5 py-1.5 font-mono text-[11px] text-primary/50 uppercase tracking-wider backdrop-blur transition-colors hover:border-primary/50 hover:text-primary disabled:opacity-60"
    >
      <span aria-hidden="true">🎮</span>
      {isConnecting ? 'Connecting…' : 'Connect controller'}
    </button>
  );
}
